import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import template from "./text_facet.html";

function TextFacet(search_model, facet, expanded, active, custom, is_control) {
    console.error("sm:", search_model);
    Object.assign(this,  {
        "type": "text",
        "template": template,
        "caption": facet.caption,
        "name": facet.name,
        "icon": facet.icon || "fa-text",
        "colour": facet.colour || "light-sea-green",
        "custom": custom,
        "data": ko.observable(null),
        "selected": active.indexOf(facet.name) >= 0,
        "visible": ko.observable(true),
        "is_control": is_control === true
    });
    var f = this;
    if (this.selected) {
        var datum = search_model.faceting.active()[active.indexOf(facet.name)];
        if (datum && datum.value) {
            this.data(datum.value);
        }
    } else {
        var current_value = null;
        search_model.faceting.active().filter((f) => {
            return f.name == facet.name
        }).forEach((f) => {
            current_value = f.value;
        });
        if (current_value) {
            this.data(current_value);
        }
    }

    this.selectFacet = function () {
        var idx = -1;
        if (f.is_control) {
            ko.unwrap(search_model.faceting.active).forEach((v,i) => {
                if (v.name == f.name)
                    idx = i;
            })
            if (idx >= 0) {
                search_model.faceting.active.splice(idx,1);
            }
        }
        var txt = f.data();
        if (!txt || txt == "") {
            f.selected = false;
        } else {
            let filt = {
                "name": f.name,
                "value": txt,
                "valueCaption": txt,
                "selector": (f.field || f.name)+":"+txt,
                "caption": facet.caption,
                "join": facet.join
            };
            if (idx >= 0) {
                search_model.faceting.active.splice(idx,0,filt);
            } else {
                search_model.faceting.active.push(filt);
            }
            f.selected = true;
        }
        search_model.pager.start_index(0);
        search_model.query_results();
    };
    this.expanded = ko.observable(expanded || is_control);
    this.expand = function () {
        f.expanded(!f.expanded());
    };

    this.handleKey = function(ui, e) {
        if (e.keyCode == 13) {
            e.preventDefault();
            e.stopPropagation();
            return f.selectFacet();
        }
        return true;
    }
}
export default TextFacet;